import React, { useEffect, useRef, useState } from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { HistoryAndCommentLoader } from "../../component/LoadersTemplate";
import LoaderTemplate from "../../component/LoaderTemplate";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import MeetingDecisions from "../IssueHistoryAndComments/MeetingDecisions";
import NoMeetings from "../../assets/NO_DECISION.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TRUE } from "node-sass";
import { Form, Spinner } from "react-bootstrap";

const CustomPrevArrow = ({
  className,
  style,
  onClick,
  currentSlide,
  totalSlides
}) => {
  const isDisabled = currentSlide === 0 || currentSlide === totalSlides - 1;
  return (
    <>
      <button
        type="button"
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        {" "}
        Previous
      </button>
      <label title="" className="previous-tip">
        Previous
      </label>
    </>
  );
};

const CustomNextArrow = ({
  className,
  style,
  onClick,
  currentSlide,
  totalSlides
}) => {
  const isDisabled = currentSlide === 0 || currentSlide === totalSlides - 1;
  return (
    <>
      <div className="slider-count">
        {currentSlide + 1}/{totalSlides}
      </div>
      <button
        type="button"
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        {" "}
        Next
      </button>
      <label title="" className="next-tip">
        Next
      </label>
    </>
  );
};

const Decision = ({ isLoading, data, template }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [localLoader, setLocalLoader] = useState(false);

  const sliderRef = useRef();

  useEffect(() => {
    if (data) {
      const filtered = isActive
        ? data.filter(item => item.meetingId !== null)
        : data;

      setFilteredData(filtered);
      setTotalSlides(filtered.length);
    }
  }, [data, isActive]);

  let settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    beforeChange: (current, next) => {
      setCurrentSlideIndex(next);
    },
    nextArrow: (
      <CustomNextArrow
        onClick={() => sliderRef.current.slickNext()}
        currentSlide={currentSlideIndex}
        totalSlides={totalSlides}
      />
    ),
    prevArrow: (
      <CustomPrevArrow
        onClick={() => sliderRef.current.slickPrev()}
        currentSlide={currentSlideIndex}
        totalSlides={totalSlides}
      />
    )
  };

  return (
    <div className="history-activity-content">
      {isLoading === STATUS.LOADING ? (
        <LoaderTemplate
          height={80}
          width={300}
          children={<HistoryAndCommentLoader />}
        />
      ) : isValidArray(data) ? (
        <div className="slider-with-toggle">
          <div className="d-flex mt-1 mr-n2">
            <Form.Group
              controlId="review_meeting_decisions"
              className="mb-0 mr-2 d-flex align-items-center"
            >
              <OverlayTrigger
                overlay={
                  <Tooltip
                    id="tooltip-pdf"
                    className={`decision-toggle-tooltip ${""}`}
                    arrowProps={{ variant: false }}
                  >
                    {
                      "Filter only the Minutes recorded during Review Meetings. Other actions will be hidden."
                    }
                  </Tooltip>
                }
              >
                <div className="toggle-overlay-wrapper">
                  <Form.Check
                    type="checkbox"
                    label="Review Meeting Decisions"
                    inline
                    checked={isActive}
                    onChange={() => {
                      setLocalLoader(true);
                      setTimeout(() => setLocalLoader(false), 1200);
                      setIsActive(prev => !prev);
                    }}
                    className={`form-toggle ${isActive ? "checked" : ""}`}
                  />
                </div>
              </OverlayTrigger>
            </Form.Group>

            <p className="mb-0 mr-n3 pr-1 decision-toggle-label">
              Review Meeting Decisions
            </p>
          </div>

          <div
            className={
              totalSlides == 1 ? "slick-slider single-slide" : "slick-slider"
            }
          >
            <Slider {...settings} className="decisionSlider" ref={sliderRef}>
              {localLoader ? (
                <LoaderTemplate
                  height={80}
                  width={300}
                  children={<HistoryAndCommentLoader />}
                />
              ) : isValidArray(filteredData) ? (
                filteredData.map((list, index) => (
                  <MeetingDecisions
                    momDesc="true"
                    meetingDecisionDTOS={list}
                    key={`mom-${index}`}
                    dataObj={data}
                  />
                ))
              ) : (
                <div className="no-data">
                  <Image
                    src={NoMeetings}
                    alt="No meetings"
                    className="no-meetings-image"
                  />
                </div>
              )}
            </Slider>
          </div>
        </div>
      ) : (
        <div className="no-data">
          <Image
            src={NoMeetings}
            alt="No meetings"
            className="no-meetings-image"
          />
        </div>
      )}
    </div>
  );
};

export default Decision;
